import React, { FC, memo, ReactNode, useEffect, useState } from 'react'
import s from './DailyCarousel.module.sass'
import { SectionCarousel } from '@shared/ui/Layout/SectionCarousel'
import { DailyCard } from '@widgets/Common/Daily/DailyCard'
import { RestCardSkeleton } from '@widgets/Restaurant/RestCards/RestCard'
import { TypeMappingDailyGQLOutput } from '@shared/api/middleware/mappingAPI/gql_daily/type'
import { LightGQL } from '@shared/api/gql-service/LightGQLService'
import { MAPPING_API_GQL } from '@shared/api/middleware/mappingAPI'
import { GQL_TAGS } from '@shared/api/api.gql'

interface Props {
  container?: React.ComponentType<{ children: ReactNode; classNameContainer?: string }>
  className?: string
}

const DefaultContainer: FC<{ children: ReactNode; classNameContainer?: string }> = ({
  children,
  classNameContainer,
}) => {
  return <div className={classNameContainer}>{children}</div>
}

const DailyCarousel: FC<Props> = ({ container, className = '' }) => {
  const [arrArticle, setArrArticle] = useState<TypeMappingDailyGQLOutput[]>()
  const [loading, setLoading] = useState(true)
  const Container = container || DefaultContainer
  const isVisible = (loading && !arrArticle) || !!arrArticle?.length

  useEffect(() => {
    LightGQL.daily
      .query(GQL_TAGS.DAILY, {
        mapping: MAPPING_API_GQL.daily,
        hash: '2f8b75c9c21abef58d02f3a117391729cef91652c8f38151ab5bf60543b7551e',
      })
      .then((data) => {
        setArrArticle(data as TypeMappingDailyGQLOutput[])
      })
      .finally(() => setLoading(false))
  }, [])

  return (
    isVisible && (
      <Container classNameContainer={className}>
        <SectionCarousel
          title={'Афиша Daily'}
          link={'https://daily.afisha.ru/'}
          skeleton={loading}
          className={s.carousel}>
          <SectionCarousel.Skeletons>
            {Array.from(Array(4).keys()).map((i, idx) => (
              <RestCardSkeleton key={idx} sizes={'L ML'} />
            ))}
          </SectionCarousel.Skeletons>
          <SectionCarousel.Items>
            {arrArticle?.map((article) => (
              <DailyCard key={article.id} title={article.title} url={article.url} img={article.img[0]} />
            ))}
          </SectionCarousel.Items>
        </SectionCarousel>
      </Container>
    )
  )
}

export default memo(DailyCarousel)
